let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ki9Rk")).then(() => parcelRequire('6qqPD'));